import { routes } from "../../lib/nav";
import { SITE_URL } from "../../lib/site";
import type { CaseStudy } from "./types";

const dir = "/cases/greymy";

const img = (file: string, alt: string, span: 2 | 3 | 6 = 6) => ({
  src: `${dir}/${file}.webp`,
  alt,
  width: 1920,
  height: 1200,
  wide: span === 6,
  span,
});

const mobile = (file: string, alt: string) => ({
  src: `${dir}/${file}.webp`,
  alt,
  width: 1920,
  height: 1200,
  span: 3 as const,
});

export const greymy: CaseStudy = {
  slug: "greymy",
  title: "GREYMY",
  cardTitle: "Разработка интернет-магазина профессиональной косметики для волос GREYMY",
  subtitle: "Профессиональная косметика для волос",
  industry: { label: "Красота и косметология", slug: "beauty" },
  eyebrow: "Интернет-магазин · Профессиональная косметика",
  h1: "Разработка интернет-магазина профессиональной косметики GREYMY",
  lead:
    "Разработали интернет-магазин профессиональной косметики для волос GREYMY: каталог с фильтром по эффекту, карточку товара с вариантами объёма, корзину и оплату частями.",
  heroButtons: { site: "Смотреть сайт", discuss: "Обсудить интернет-магазин косметики" },

  seo: {
    primaryKeyword: "разработка интернет-магазина профессиональной косметики для волос",
    secondaryKeywords: [
      "сайт бренда профессиональной косметики",
      "интернет-магазин косметики для волос",
      "e-commerce для салонного бренда",
      "сайт косметического бренда B2B B2C",
    ],
    semanticEntities: [
      "каталог по эффекту",
      "карточка товара с вариантами объёма",
      "рейтинги и отзывы",
      "избранное",
      "корзина",
      "оплата долями",
    ],
    excludedKeywords: [
      "косметика для волос купить",
      "шампунь GREYMY",
      "уход за волосами",
      "салонная косметика",
    ],
    title: "Интернет-магазин GREYMY — кейс HAY.agency",
    description:
      "Кейс HAY.agency: e-commerce профессионального hair-care бренда с каталогом, обучением, партнёрским направлением и сценариями для салонов.",
    h1: "Разработка интернет-магазина профессиональной косметики GREYMY",
    slug: "greymy",
    canonicalUrl: `${SITE_URL}/cases/greymy`,
    ogTitle: "Интернет-магазин профессиональной косметики GREYMY",
    ogDescription:
      "Каталог по эффекту, карточка с вариантами объёма, корзина, оплата долями и мобильный путь покупки.",
    ogImage: `${SITE_URL}${dir}/greymy-og.webp`,
    robotsIndex: true,
    datePublished: "2023-01-01",
    dateModified: "2026-09-01",
  },

  links: {
    relatedService: {
      label: "Разработка и развитие интернет-магазинов",
      to: routes.ecom,
      note: "Каталог, карточка товара и оформление заказа",
    },
    relatedIndustry: {
      label: "SEO-продвижение интернет-магазинов",
      to: routes.seo,
      note: "Видимость каталога и категорий",
    },
    relatedCases: [
      {
        label: "E-commerce платформа для производителя косметики Levrana",
        to: "/cases/levrana",
        note: "Мультибрендовый каталог косметики",
      },
      {
        label: "Интернет-магазин премиального бренда BYRAIN",
        to: "/cases/byrain",
        note: "Каталог и карточка товара для косметического бренда",
      },
    ],
    relatedArticles: [],
  },

  cta: {
    title: "Нужен интернет-магазин профессиональной косметики?",
    text: "Спроектируем каталог по эффекту, карточку с вариантами объёма и e-commerce сценарии покупки.",
    button: "Обсудить интернет-магазин косметики",
  },

  client: {
    name: "GREYMY",
    url: "https://greymy.ru/",
    city: "Москва",
    industry: "Профессиональная косметика для волос",
  },
  year: "2023",
  services: [
    "Дизайн интернет-магазина",
    "Разработка каталога с фильтром по эффекту",
    "Карточка товара с вариантами объёма",
    "Корзина и оплата частями",
  ],
  platform: "1С-Битрикс",
  tags: [
    { label: "Интернет-магазин", to: routes.ecom },
    { label: "Разработка", to: routes.ecom },
  ],
  facts: [
    { label: "Клиент", value: "GREYMY" },
    { label: "Тип проекта", value: "Интернет-магазин профессиональной косметики" },
    { label: "Платформа", value: "1С-Битрикс" },
    { label: "Год", value: "2023" },
  ],

  results: {
    title: "Что реализовали",
    items: [
      "Интернет-магазин профессиональной косметики для волос",
      "Каталог с фильтром по эффекту и продуктовыми категориями",
      "Карточка товара с вариантами объёма, рейтингом и отзывами",
      "Избранное и корзина с оплатой «Долями»",
      "Мобильный путь покупки от каталога до оформления заказа",
    ],
  },

  story: [
    {
      title: "Задача",
      paragraphs: [
        "GREYMY — бренд профессиональной косметики для волос, работающий и с салонами, и с розничным покупателем. Нужен был каталог, который ведёт к нужному продукту по эффекту, типу волос и составу.",
        "Вторая часть задачи — собрать полноценный e-commerce сценарий: карточку с вариантами объёма, рейтинги, избранное, корзину и современные способы оплаты.",
      ],
    },
  ],
  features: [],

  design: {
    title: "Дизайн: премиальная нейтральная подача",
    paragraphs: [
      "Интерфейс собран на премиальной нейтральной подложке с packshot продукции — без типового beauty-коллажа с листьями.",
      "Каталог и карточка товара выстроены так, чтобы фильтр по эффекту и варианты объёма считывались с первого взгляда.",
    ],
    bullets: [
      "Премиальная нейтральная подложка вместо белого фона",
      "Фильтр каталога по эффекту",
      "Карточка с вариантами объёма и быстрым добавлением в корзину",
    ],
  },

  identity: {
    fonts: [
      { name: "Open Sans", role: "Заголовки", sample: "Каталог GREYMY" },
      { name: "Inter", role: "Интерфейс и описания", sample: "Варианты объёма" },
    ],
    colors: [
      { hex: "#F4F1EC", name: "Фон витрины" },
      { hex: "#3B3A38", name: "Акцент бренда" },
      { hex: "#1A1918", name: "Текст" },
    ],
  },

  cover: img(
    "greymy-case-cover",
    "Главная страница интернет-магазина профессиональной косметики GREYMY",
    6,
  ),

  gallery: [
    img("greymy-catalog-filters", "Каталог GREYMY с фильтром по эффекту", 6),
    img("greymy-product-card", "Карточка товара GREYMY с вариантами объёма", 6),
  ],

  responsive: {
    text: [
      "Мобильная версия повторяет логику десктопа: фильтр по эффекту, карточка товара, корзина и оплата.",
      "Состояния корзины и избранного в мобильной версии показаны заполненными.",
    ],
    images: [
      mobile("greymy-mobile-home", "Мобильная главная интернет-магазина GREYMY"),
      mobile("greymy-mobile-cart", "Мобильная корзина и оплата GREYMY"),
    ],
  },

  columnBlocks: [
    {
      id: "catalog",
      title: "Каталог по задаче волос",
      paragraphs: [
        "Каталог фильтруется по эффекту и типу продукта — покупатель быстрее находит подходящее средство.",
      ],
      bullets: ["Фильтры по эффекту", "Продуктовые категории"],
    },
    {
      id: "card",
      title: "Карточка с вариациями",
      paragraphs: [
        "Карточка товара показывает варианты объёма, рейтинг и отзывы, цену и добавление в корзину.",
      ],
      columns: [
        { title: "Варианты", items: ["Объём", "Цена"] },
        { title: "Доверие", items: ["Рейтинг", "Отзывы"] },
      ],
    },
    {
      id: "checkout",
      title: "Оплата и e-commerce",
      paragraphs: [
        "Заполненная корзина, оплата «Долями» и мобильный путь покупки формируют завершённый e-commerce сценарий.",
      ],
      bullets: ["Корзина", "Оплата «Долями»", "Мобильный путь покупки"],
    },
  ],

  servicesDone: {
    title: "Комплекс работ HAY.agency",
    items: [
      { label: "Разработка интернет-магазина", to: routes.ecom },
    ],
  },
};
